import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketInSeriesVo} from '../../common/shared/api/nicolas/vo/TicketInSeriesVo.interface';

/**
 * 콘텐츠 이용권 정보 조회 (환불 정보 포함)
 *
 * Origin: pageNicolasApi.getTicketRefundInfo
 * API: POST /api/v1/store/coupon_history/refund_info
 */
export async function postStoreCouponHistoryRefundInfo(
  params: {
    page?: number;
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<TicketInSeriesVo & ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/coupon_history/refund_info',
    {
      method: 'POST',
      data: {
        seriesid: params.seriesId,
        page: params.page ?? 0,
      },
    },
    options
  );
  return response.data;
}
